import { isNil } from 'lodash'
import type { Alpha3Code } from 'i18n-iso-countries'
import i18nCountries from 'i18n-iso-countries'
import countriesFrLang from 'i18n-iso-countries/langs/fr.json'
import countriesEnLang from 'i18n-iso-countries/langs/en.json'

import type { Currency } from '@/shared/models/moneyModel'
import type { CountryCode } from '@/shared/models/debtorModels'
import { EMPTY_VALUE } from '@hello-aria/ui/empty-value'

i18nCountries.registerLocale(countriesEnLang)
i18nCountries.registerLocale(countriesFrLang)

export type LocalizeAmountsOptions = {
    currencyDisplay?: Intl.NumberFormatOptionsCurrencyDisplay
    locale?: string
}

export const localizeAmounts = (
    amount: number | string | undefined | null,
    currency: Currency | null | undefined,
    { currencyDisplay = 'symbol', locale = 'en' }: LocalizeAmountsOptions
): string => {
    return !isNil(amount) && !isNil(currency)
        ? (typeof amount === 'string' ? Number(amount) : amount).toLocaleString(locale, {
              style: 'currency',
              currency,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              currencyDisplay
          })
        : EMPTY_VALUE
}

export type LocalizeMonthProps = {
    month: number
    locale?: string
}

export const localizeMonth = ({ month, locale = 'en' }: LocalizeMonthProps): string | null => {
    const formatter = new Intl.DateTimeFormat(locale, { month: 'long' })
    const format = (date: Date) => formatter.format(date)
    if (month >= 0 && month <= 11) {
        const result = format(new Date(Date.UTC(2021, month % 12)))
        return result.charAt(0).toUpperCase() + result.slice(1)
    }
    return null
}

export type LocalizeCountryProps = {
    countryCode: undefined | number | CountryCode | Alpha3Code | (string & {})
    locale: string
}

export const localizeCountry = ({ countryCode, locale }: LocalizeCountryProps): string | undefined => {
    return i18nCountries.getName(countryCode ?? '', locale ?? '')
}
